import script from "./VehicleListingsCustomPhrase.vue?vue&type=script&lang=js"
export * from "./VehicleListingsCustomPhrase.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__